import { postBookingDraftConfirm, type ApiResponse } from '@dc-trans/data-layer';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { mergeApiErrorNotificationMeta, type MutationOptionsWithNotification } from '@/mutations/utils';

type BookingDraftConfirmVariables = {
  id: string;
  payload: any;
};

export const usePostBookingDraftConfirm = (
  options?: MutationOptionsWithNotification<
    ApiResponse<any>,
    AxiosError<ApiResponse<any>>,
    BookingDraftConfirmVariables
  >
) => {
  const { disableErrorNotification, meta, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal mengkonfirmasi booking.',
    },
    meta,
    disableErrorNotification
  );

  return useMutation<ApiResponse<any>, AxiosError<ApiResponse<any>>, BookingDraftConfirmVariables>({
    ...restOptions,
    mutationFn: args => postBookingDraftConfirm(args.id, args.payload),
    meta: mergedMeta,
  });
};
